const indexItems = [
  { title: '海角视频区', desc: '原创视频', icon: 'ri-movie-line' },
  { title: '社区广场', desc: '互动交流', icon: 'ri-chat-smile-2-line' },
  { title: '论坛讨论', desc: '深度话题', icon: 'ri-discuss-line' },
  { title: '海角社', desc: '专题策划', icon: 'ri-star-line' },
  { title: '创作者中心', desc: '作品管理', icon: 'ri-pencil-ruler-line' },
  { title: '发现页', desc: '内容推荐', icon: 'ri-compass-discover-line' },
  { title: '排行榜', desc: '热门排序', icon: 'ri-bar-chart-2-line' },
  { title: '收藏夹', desc: '我的收藏', icon: 'ri-bookmark-line' },
  { title: '设置中心', desc: '个性化', icon: 'ri-settings-3-line' },
];

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            主题索引
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            海角网核心板块快速导航
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center gap-3 bg-background-50 rounded-xl p-4 border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all duration-200 cursor-pointer group"
            >
              <div className="w-9 h-9 rounded-lg bg-primary-50 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-base text-primary-600`}></i>
              </div>
              <div className="min-w-0">
                <div className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </div>
                <div className="text-xs text-foreground-500">{item.desc}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}